import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Routes where only slug / param changes (e.g. demo game selection)
 * should preserve scroll position instead of jumping to top.
 */
const SAME_SCROLL_CONTEXT_PREFIXES = [
  "/ewallet-casino-providers",
  "/bng-ewallet-slots",
  "/cq9-ewallet-casino-games",
  "/pegasus-ewallet-games",
  "/joker-online-slots",
  "/rich-gaming-ewallet-games",
] as const;

function getScrollContext(pathname: string): string {
  for (const prefix of SAME_SCROLL_CONTEXT_PREFIXES) {
    if (pathname === prefix || pathname.startsWith(`${prefix}/`)) {
      return prefix;
    }
  }
  return pathname;
}

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();
  const prevPathnameRef = useRef<string | null>(null);

  useEffect(() => {
    const prevPathname = prevPathnameRef.current;
    prevPathnameRef.current = pathname;

    // PUSH / REPLACE：前進導航時置頂，讓用戶從新頁面頂部開始閱讀
    if (navigationType === "PUSH" || navigationType === "REPLACE") {
      if (hash) {
        // 有 hash 錨點時不置頂，交由瀏覽器處理錨點滾動
        return;
      }

      const stayingInSameScrollContext =
        prevPathname != null &&
        getScrollContext(prevPathname) === getScrollContext(pathname);

      if (stayingInSameScrollContext) {
        return;
      }

      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    // POP：後退/前進時不干預，交由瀏覽器 scrollRestoration 還原滾動位置
  }, [pathname, hash, navigationType]);

  return null;
}
